<template>
    <div>

        <div class="card">
            <div class="card-body">
                <button type="button" style="float: right" data-bs-toggle="modal"
                    data-bs-target="#createPickingListModal" class="btn btn-primary px-5">New Picking List</button>
                <pagination @search="load" :data="pagination"></pagination>

                <table id="example" class="table table-hover" style="width:100%">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="list in pickinglists" :key="list.id" style="cursor: pointer;">
                            <td @click="$router.push({ name: 'admin.products.list.view', params: { id: list.id } })">{{ list.name }}</td>
                            <td @click="$router.push({ name: 'admin.products.list.view', params: { id: list.id } })">{{ list.description }}</td>
                            <td><button class="btn btn-sm btn-danger" @click="remove(list.id)">Remove</button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </tfoot>
                </table>

                <pagination @search="load" :data="pagination"></pagination>
            </div>
        </div>

        <!-- MODALS -->

        <div class="modal fade" id="createPickingListModal" tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Picking List</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 mb-2">
                                <p>Fields marked <span class="text-danger">*</span> are required</p>
                            </div>
                            <div class="col-md-12 mb-2">
                                <label for="pickinglistName" class="form-label">Name <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="pickinglistName" v-model="pickinglist.name">
                            </div>
                            <div class="col-md-12 mb-2">
                                <label for="pickinglistDescription" class="form-label">Description <span
                                        class="text-danger">*</span></label>
                                <textarea class="form-control" id="pickinglistDescription"
                                    v-model="pickinglist.description"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            id='closeCreatePickingListModal'>Close</button>
                        <submit-button type="button" :background="'btn btn-primary'" :clicked="creating" @click="create"
                            text="Save changes"></submit-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
/* global $ */
import axios from 'axios';
import Pagination from '../../../components/Pagination.vue';
import SubmitButton from '../../../components/SubmitButton.vue';
export default {
    components: { Pagination, SubmitButton },
    name: 'admin.products.list',
    data() {
        return {
            pickinglists: [],
            pagination: {
                lastPage: 0,
                page: 0,
                showing: 0,
                total: 0
            },
            pickinglist: {
                name: '',
                description: ''
            },
            creating: false
        }
    },
    mounted() {
        this.load()
    },
    methods: {
        load(page = 1) {
            axios.get(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist/view?page=${page}`)
                .then(response => {
                    this.pickinglists = response.data.pickinglist;
                    this.pagination = response.data.pagination;
                })
                .catch(error => {
                    this.$error('Failed to load picking list.', error);
                });
        },
        create() {
            this.creating = true;
            axios.post(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist`, {
                name: this.pickinglist.name,
                description: this.pickinglist.description
            })
                .then(() => {
                    $('#closeCreatePickingListModal').click();
                    this.$success("Created new picking list.");
                    this.creating = false;
                    this.pickinglist = {
                        name: '',
                        description: ''
                    }
                    this.load(this.pagination.page);
                })
                .catch(error => {
                    this.$error("Failed to create new picking list.", error);
                    this.creating = false;
                })
        },
        remove(id) {
            axios.delete(`${process.env.VUE_APP_API_URL}/v1/product/pickinglist/${id}`)
                .then(() => {
                    this.pickinglists = [];
                    this.pagination = {
                        lastPage: 0,
                        page: 0,
                        showing: 0,
                        total: 0
                    };
                    this.load();
                    this.$success("Picking list deleted.");
                })
                .catch(error => {
                    this.$error("Failed to delete picking list.", error);
                })
        },
    }
}
</script>